import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
// tslint:disable-next-line:import-blacklist
import { Subscription } from 'rxjs';
import { NewsletterService } from '../../services/newsletter.service';
import { NewsletterViewModel } from '../../models/catalogue-view.model';
import { FileService } from '../../services/file.service';
import { NgProgressService } from '../../services/ngProgress.service';

declare var jquery: any;
declare var $: any;
@Component({
  selector: 'app-newsletter-detail-v2',
  templateUrl: './newsletter-detail-v2.component.html',
  styleUrls: ['./newsletter-detail-v2.component.css']
})
export class NewsletterDetailV2Component implements OnInit {

  title: string;
  subscriptionActiveRouter: Subscription;
  subscriptionActiveRouterParent: Subscription;
  subscriptionRouterParaChange: Subscription;
  subscriptionGetNewsletter: Subscription;
  newsId: string;
  newsletterView: NewsletterViewModel;

  errorMsg = false;
  url: string;
  pipedDescription: string;
  loadContent = false;
  text = '';

  constructor(
    private activeRouter: ActivatedRoute,
    public ngProgress: NgProgressService,
    private newsletterService: NewsletterService,
    private router: Router,
    private fileService: FileService,
  ) {
  }

  ngOnInit() {
    this.text = 'My rendered <b>html</b>';
    /*subscript to watch the route para changes.
    **************Please make changes inside this subscription. Don't delete it ***************/
    this.subscriptionRouterParaChange = this.activeRouter.paramMap.subscribe(param => {
      $('.child-loader').animate({ scrollLeft: $('#cataloguelist').width() }, 100);
      this.newsId = param.get('sku');
      this.loadContent = false;
      this.newsletterView = null;
      this.subscriptionActiveRouter = this.activeRouter.url.subscribe(value => {
        this.title = value[0].path.toUpperCase();
      },
        (error: any) => {
          console.error(error);
          this.ngProgress.done();
        });

      this.subscriptionGetNewsletter = this.newsletterService.getNewsletterView(this.newsId)
        .subscribe(
          (data: NewsletterViewModel) => {
            this.errorMsg = false;
            this.newsletterView = data;
            this.loadContent = true;
            
          },
          (error: any) => {
            this.errorMsg = true;
            console.log(this.errorMsg);
            console.error(error);
            this.ngProgress.done();
          },
          () => {
            this.ngProgress.done();
          });
    });
  }

  renderedCb(newsId: string, vendorName: string) {

    $('#newsletter-filter .searchInput').on('change paste keyup', function () {
      const keyword: string = $(this).val().toString().trim().toLowerCase();
      $('.cms-block-products .product-row').each(function (i, obj) {
        if (obj.innerHTML.toLowerCase().includes(keyword)) {
          $(this).show();
          $(this).closest('.product-row-bundle').show();
        } else {
          $(this).hide();
          $(this).closest('.product-row-bundle').hide();
        }
      });
    });

    $('.cms-block-products .product-code a').removeAttr('href');
    $('.cms-block-products .product-code a').each(function () {
      $(this).attr('href', '/catalogues/newsletter/' + newsId + '/' + vendorName + '/product/' + encodeURIComponent($(this).html().replace(/\+/g, '^')));
    });
    $('#addToCart').removeAttr('href');
    $('#addToCardButton').each(function () {
      $(this).attr('href', '/catalogues/newsletter/' + newsId + '/' + vendorName + '/product/' + encodeURIComponent($(this).html().replace(/\+/g, '^')));
    });

    $('[data-toggle="tooltip"]').tooltip();

    // click to product detail
    $('.cms-img-hover-wrapper  div.label-primary-text').each((index, element) => {
      $(element).closest('div.cms-img-hover-wrapper').unbind('click').on('click', () => {
        this.router.navigate(['/catalogues/newsletter/' + newsId + '/' + vendorName + '/product/' + encodeURIComponent($(element).html().replace(/\+/g, '^'))]);
      });
    });

  }




  toHTML(input: any): any {
    return new DOMParser().parseFromString(input, 'text/html').documentElement.innerHTML;
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    $('.child-loader').animate({ scrollLeft: -$('#cataloguelist').width() }, 400);
    this.router.navigateByUrl('/catalogues');
  }

  ngOnDestroy(): void {

    if (this.subscriptionActiveRouter) {
      this.subscriptionActiveRouter.unsubscribe();
    }
    if (this.subscriptionActiveRouterParent) {
      this.subscriptionActiveRouterParent.unsubscribe();
    }
    if (this.subscriptionRouterParaChange) {
      this.subscriptionRouterParaChange.unsubscribe();
    }
    if (this.subscriptionGetNewsletter) {
      this.subscriptionGetNewsletter.unsubscribe();
    }
  }

  exportExcelForCatalogue(newsId: string): void {
    this.ngProgress.start();
    this.newsletterService.exportExcelForCatalogueSQL(newsId).subscribe((data: any) => {
      // const fileName = 'Dicker Data Catalogue.xlsx';
      const fileName = 'Dicker Data - ' + this.newsletterView.newsLetter.title;
      this.fileService.saveAsExcelFile(data, fileName);
      this.ngProgress.done();
    },
      (error: any) => {
        console.error(error);
        this.ngProgress.done();
      });
  }
}
